module.exports = __webpack_public_path__ + "img/khuvuc.c59ab805.svg";